/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './post.defs.js'
export * as $defs from './post.defs.js'
